import React from 'react'
import { createPortal } from 'react-dom'
import { useTranslatorWidget } from './TranslatorProvider'
import useDialogPortalTarget from './useDialogPortalTarget'
import TranslatorPanel from './TranslatorPanel'
import TranslatorBubble from './TranslatorBubble'

/**
 * Three-way shell dispatcher for the floating translator (#2892): `closed` renders nothing,
 * `minimized` the bubble, `open` the panel. A switch on `ui.status` with no translation state of
 * its own, so it never re-subscribes anything (e.g. a resize listener) that only a view needs.
 *
 * While a MUI Dialog is open the view is portaled into that dialog's container (see
 * useDialogPortalTarget): outside it the widget would be aria-hidden and unable to keep focus.
 */
const TranslatorWidget = () => {
  const { ui } = useTranslatorWidget()
  const dialogContainer = useDialogPortalTarget()

  if (ui.status === 'closed') return null
  const view = ui.status === 'minimized' ? <TranslatorBubble /> : <TranslatorPanel />
  return dialogContainer ? createPortal(view, dialogContainer) : view
}

export default TranslatorWidget
